<template>
  <v-form>
    <v-card flat>
      <v-card-text>
        <v-row class="pb-1">
          <v-col cols="4">
            <label class="datepickerLabel">{{ dateFromLabel }}</label>
            <date-picker :clearable="false"
              prefix-class="xmx"
              :append-to-body="false"
              class="datetimepicker"
              :disabled="datePickersDisabled"
              v-model="dateFrom"
              type="datetime"
              valueType="timestamp"
              :placeholder="dateFromLabel"
              format="DD.MM.YYYY HH:mm:ss"
              :default-value="new Date()"
              :disabled-date="disableDateBeforeLastBalance"></date-picker> <!-- Added disabled-date -->
          </v-col>
          <v-col cols="4">
            <label class="datepickerLabel">{{ dateToLabel }}</label>
            <date-picker :clearable="false"
              prefix-class="xmx"
              :append-to-body="false"
              class="datetimepicker"
              :disabled="datePickersDisabled"
              v-model="dateTo"
              type="datetime"
              valueType="timestamp"
              :placeholder="dateToLabel"
              format="DD.MM.YYYY HH:mm:ss"
              :default-value="new Date()"
              :disabled-date="disableDateBeforeDateFrom"></date-picker> <!-- Added disabled-date -->
          </v-col>
          <v-col cols="4">
            <v-btn class="btn infoButton mt-6 ml-5"
              @click="loadData">Dohvati</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0 mt-2 pb-0 mb-0"
            cols="6">
            <v-row class="pt-0 mt-2 pb-0 mb-0">
              <v-col class="pt-0 mt-0 pb-0 mb-0">
                <div class="pt-0 mt-0 pb-0 mb-0">
                  Novčanice:
                  <span class="font-weight-bold">{{
                    $options.filters.money(availableFunds, 100, currency)
                  }}</span>
                </div>
              </v-col>
            </v-row>
            <v-row class="pt-0 mt-2 pb-0 mb-0">
              <v-col class="pt-0 mt-0 pb-0 mb-0">
                <div class="pt-0 mt-0 pb-0 mb-0">
                  Kartice:
                  <span class="font-weight-bold">{{
                    $options.filters.money(cardFunds, 100, currency)
                  }}</span>
                </div>
              </v-col>
            </v-row>
            <v-row class="pt-0 mt-2 pb-0 mb-0">
              <v-col class="pt-0 mt-0 pb-0 mb-0">
                <div class="pt-0 mt-0 pb-0 mb-0">
                  Ostalo:
                  <span class="font-weight-bold">{{
                    $options.filters.money(otherFunds, 100, currency)
                  }}</span>
                </div>
              </v-col>
            </v-row>
            <v-row class="pt-0 mt-2 pb-0 mb-0">
              <v-col class="pt-0 mt-0 pb-0 mb-0">
                <div class="pt-0 mt-0 pb-0 mb-0">
                  Polog na blagajni:
                  <span class="font-weight-bold">{{
                    $options.filters.money(depositAmt, 100, currency)
                  }}</span>
                </div>
              </v-col>
            </v-row>
            <v-row class="pt-0 mt-2 pb-0 mb-0">
              <v-col class="pt-0 mt-0 pb-0 mb-0">
                <div class="pt-0 mt-0 pb-0 mb-0">
                  Ostatak utržka:
                  <span class="font-weight-bold">{{
                    $options.filters.money(previousAmt, 100, currency)
                  }}</span>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pt-0 mt-2 pb-0 mb-0"
            cols="6">
            <v-row class="pt-0 mt-2 pb-0 mb-0">
              <v-col class="pt-0 mt-0 pb-0 mb-0">
                <div class="pt-0 mt-0 pb-0 mb-0">
                  Napojnice (Novčanice):
                  <span class="font-weight-bold">{{
                    $options.filters.money(tipCash, 100, currency)
                  }}</span>
                </div>
              </v-col>
            </v-row>
            <v-row class="pt-0 mt-2 pb-0 mb-0">
              <v-col class="pt-0 mt-0 pb-0 mb-0">
                <div class="pt-0 mt-0 pb-0 mb-0">
                  Napojnice (Kartice):
                  <span class="font-weight-bold">{{
                    $options.filters.money(tipCard, 100, currency)
                  }}</span>
                </div>
              </v-col>
            </v-row>
            <v-row class="pt-0 mt-2 pb-0 mb-0">
              <v-col class="pt-0 mt-0 pb-0 mb-0">
                <div class="pt-0 mt-0 pb-0 mb-0">
                  Napojnice (Ukupno):
                  <span class="font-weight-bold">{{
                    $options.filters.money(tipsTotal, 100, currency)
                  }}</span>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-row class="pl-3 pt-0 mt-2 pb-0 mb-0">
            <v-col class="pt-0 mt-0 pb-0 mb-0">
              <div class="pt-0 mt-0 pb-0 mb-0">
                Ukupno novčanica u blagajni:
                <span class="font-weight-bold">{{
                  $options.filters.money(
                    availableFunds + depositAmt + previousAmt + tipCash,
                    100,
                    currency
                  )
                }}</span>
              </div>
              <div class="font-italic">
                Utržak (Novčanice)
                {{ $options.filters.money(availableFunds, 100, currency) }}
                + Polog na blagajni:
                {{ $options.filters.money(depositAmt, 100, currency) }}
                + Ostatak utržka:
                {{ $options.filters.money(previousAmt, 100, currency) }}
                + Napojnice:
                {{ $options.filters.money(tipCash, 100, currency) }}
              </div>
            </v-col>
          </v-row>

          <v-row class="pl-3 pt-0 mt-2 pb-2 mb-0">
            <v-col class="pt-0 mt-0 pb-0 mb-0">
              <div class="pt-0 mt-0 pb-0 mb-0">
                Datum zadnjeg zaključka:
                <span class="font-weight-bold">{{
                  lastBalanceTipeStamp | fullDateTime
                }}</span>
              </div>
            </v-col>
          </v-row>
        </v-row>
        <v-divider class="mt-2 pb-2"></v-divider>
        <!-- <v-row class="pt-0 mt-0 pb-0 mb-0">
          <div style="padding-left: 12px; padding-top: 0px; padding-right: 5px">
            Iznos novca za polaganje u banku:
          </div>
          <div style="margin-top: -7px !important; max-width: 15% !important">
            <quantity-input dense
              hide-details
              v-model="withdrawAmount"
              suffix="€"></quantity-input>
          </div>
        </v-row> -->
      </v-card-text>
    </v-card>
  </v-form>
</template>
<script>
import state from '@/state'
import { df, functions } from '@/plugins/firebase'
import applicationSettings from '@/mixins/applicationSettings' // don't move.. detaches firebase listeners
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css' // Importaj CSS ako već nije globalno
import 'vue2-datepicker/locale/hr' // Importaj HR locale ako trebaš

export default {
  name: 'CloseBalance',
  mixins: [applicationSettings],
  components: { DatePicker },
  props: {
    tab: String
  },
  data: function () {
    return {
      cashLeft: 0,
      availableFunds: 0,
      cardFunds: 0,
      otherFunds: 0,
      depositAmt: 0,
      maxHoldingAmt: 0,
      lastBalanceTipeStamp: 0,
      receiptPrint: true,
      currency: 'EUR',
      withdrawAmount: 0,
      previousAmt: 0,
      tips: [],
      tipCash: 0,
      tipCard: 0,
      tipsTotal: 0,
      dateFrom: null, // Pohranjuje datum u YYYY-MM-DD formatu za v-date-picker
      dateTo: new Date().toISOString().substr(0, 10), // Defaultno danasnji datum
      lastBalanceTimestamp: null, // Ostaje (timestamp u sekundama)
      datePickersDisabled: false, // Dodaj ako ne postoji
      dateFromLabel: 'Datum od', // Dodaj labelu
      dateToLabel: 'Datum do' // Dodaj labelu
    }
  },
  computed: {
    dateNow () {
      return Date.now() / 1000
    },
    lastBalance () {
      // Ensure lastBalanceTimestamp is valid before formatting
      if (!this.lastBalanceTimestamp) return 'N/A'
      // Formatiraj timestamp iz sekundi u čitljiv datum
      const date = new Date(this.lastBalanceTimestamp * 1000)
      return date.toLocaleDateString('hr-HR')
    }

  },
  watch: {
    receiptPrint (val) {
      this.$emit('receiptPrint', val)
    },
    tab (nv) {
      if (nv === 'ClosingBalanceTimeRange') {
        this.load()
      }
    }
  },
  mounted () {
    this.currency = 'HRK'
    if (Date.now() / 1000 > 1672527599) {
      this.currency = 'EUR'
    }
    const listener = df.doc(`cash_registers/${state.getCashRegister().id}`).onSnapshot(doc => {
      this.resetValues()
      const document = doc.data()
      if (!document) {
        this.resetValues()
        // Postavi defaultne datume ako nema podataka
        const now = new Date()
        const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0)
        this.dateFrom = startOfDay.getTime() // Timestamp u ms za početak današnjeg dana
        this.dateTo = now.getTime() // Trenutni timestamp u ms
        this.lastBalanceTimestamp = null // Osiguraj da je null ako nema dokumenta
        this.lastBalanceTipeStamp = 0 // Resetiraj i display timestamp
        return
      }

      this.lastBalanceTimestamp = document?.last_balance_timestamp || null
      // Ažuriraj i display timestamp (pretpostavljamo da je ista vrijednost)
      this.lastBalanceTipeStamp = document?.last_balance_timestamp || 0

      if (this.lastBalanceTimestamp) {
        // Konvertiraj sekunde u milisekunde za date picker (valueType="timestamp")
        this.dateFrom = this.lastBalanceTimestamp * 1000
      } else {
        // Fallback: Ako nema zadnjeg zaključka, postavi 'Datum od' na početak današnjeg dana
        console.warn("Nije pronađen timestamp zadnjeg zaključka, 'Datum od' postavljen na početak današnjeg dana.")
        const now = new Date()
        const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0)
        this.dateFrom = startOfDay.getTime() // timestamp u ms
      }
      this.dateTo = Date.now() // timestamp u ms

      if (this.dateTo < this.dateFrom) {
        this.dateTo = this.dateFrom
      }

      this.availableFunds = document.available_funds || 0
      this.cardFunds = document.card_funds || 0

      var previousFunds = document.previous_funds ? document.previous_funds : 0
      this.withdrawAmount = ((this.availableFunds / 100) + (previousFunds / 100)).toFixed(2) || 0
      this.otherFunds = document.other_funds || 0
      this.depositAmt = document.deposit?.amt || 0
      this.previousAmt = document.previous_funds || 0
      this.maxHoldingAmt = document.max_holding || 0
      this.cashLeft = this.maxHoldingAmt - this.depositAmt - this.availableFunds
      this.lastBalanceTipeStamp = document.last_balance_timestamp
      this.getTips()
    })
    this.listeners.push(listener)
  },
  methods: {
    getBalanceAmounts () {
      var amount = {
        // withdrawAmount: Math.round(parseFloat(this.withdrawAmount || 0) * 100),
        // availableFunds: this.availableFunds,
        // depositAmount: this.depositAmt,
        // previousAmount: this.previousAmt,
        dateFromTimestamp: this.dateFrom ? Math.floor(this.dateFrom / 1000) : null,
        dateToTimestamp: this.dateTo ? Math.floor(this.dateTo / 1000) : null
      }
      return amount
    },
    disableDateBeforeLastBalance (date) {
      // Onemogući datume prije dana zadnjeg zaključka
      // 'date' je Date objekt koji vue2-datepicker šalje
      if (!this.lastBalanceTimestamp) {
        return false // Ako nema zadnjeg zaključka, ne onemogućavaj ništa
      }
      // Kreiraj Date objekt od timestampa zadnjeg zaključka (koji je u sekundama)
      const lastBalanceDayStart = new Date(this.lastBalanceTimestamp * 1000)
      // Postavi na početak dana (00:00:00) da bi usporedba bila točna samo za dane
      lastBalanceDayStart.setHours(0, 0, 0, 0)
      // Onemogući ako je 'date' prije početka dana zadnjeg zaključka
      return date.getTime() < lastBalanceDayStart.getTime()
    },
    disableDateBeforeDateFrom (date) {
      // Onemogući datume prije odabranog "Datum od"
      // 'date' je Date objekt koji vue2-datepicker šalje
      if (!this.dateFrom) {
        return false // Ako "Datum od" nije odabran (null ili 0), ne onemogućavaj ništa
      }
      // Kreiraj Date objekt od 'dateFrom' timestampa (koji je u milisekundama)
      const dateFromDayStart = new Date(this.dateFrom)
      // Postavi na početak dana (00:00:00)
      dateFromDayStart.setHours(0, 0, 0, 0)
      // Onemogući ako je 'date' prije početka dana odabranog 'dateFrom'
      return date.getTime() < dateFromDayStart.getTime()
    },
    loadData () {
      if (!this.dateFrom || !this.dateTo) {
        // Koristi showMsgBox ako je dostupan preko inject ili mixin-a
        if (typeof this.showMsgBox === 'function') {
          this.showMsgBox({
            text: 'Molimo odaberite "Datum od" i "Datum do".',
            actions: ['cancel'],
            cancelBtnText: this.$t('$vuetify.close'),
            color: 'warning'
          })
        } else {
          alert('Molimo odaberite "Datum od" i "Datum do".')
        }
        return
      }

      // Provjeri jesu li dateFrom i dateTo validni brojevi (timestamps)
      if (isNaN(this.dateFrom) || isNaN(this.dateTo)) {
        if (typeof this.showMsgBox === 'function') {
          this.showMsgBox({
            text: 'Odabrani datumi nisu ispravni.',
            actions: ['cancel'],
            cancelBtnText: this.$t('$vuetify.close'),
            color: 'error'
          })
        } else {
          alert('Odabrani datumi nisu ispravni.')
        }
        return
      }

      // Provjeri redoslijed datuma
      if (this.dateTo < this.dateFrom) {
        if (typeof this.showMsgBox === 'function') {
          this.showMsgBox({
            text: '"Datum do" ne može biti prije "Datuma od".',
            actions: ['cancel'],
            cancelBtnText: this.$t('$vuetify.close'),
            color: 'error'
          })
        } else {
          alert('"Datum do" ne može biti prije "Datuma od".')
        }
        return
      }

      this.$emit('loading', true)
      this.datePickersDisabled = true // Onemogući pickere tijekom učitavanja
      var balancepreview = functions.httpsCallable('balancepreview')

      // Konvertiraj timestampove iz milisekundi u sekunde za API
      const dateFromTimestamp = Math.floor(this.dateFrom / 1000)
      const dateToTimestamp = Math.floor(this.dateTo / 1000)

      balancepreview({
        company_id: state.getCurrentCompany().id,
        location_id: state.getPointOfSale().id,
        register_id: state.getCashRegister().id,
        from: dateFromTimestamp, // timestamp u sekundama
        to: dateToTimestamp // timestamp u sekundama
        // user_id: state.getUser().id,
        // totals: true

      })
        .then((result) => {
          // Resetiraj vrijednosti prije primjene dohvaćenih podataka
          this.availableFunds = 0
          this.cardFunds = 0
          this.otherFunds = 0
          this.tipCard = 0
          this.tipCash = 0
          this.tipsTotal = 0

          if (result.data.balance_report.rekapitulacija_prometa.promet_po_placanjima) {
            result.data.balance_report.rekapitulacija_prometa.promet_po_placanjima.forEach(promet => {
              switch (promet.nacin_placanja) {
                case 'NOVČANICE':

                  if (typeof promet.iznos === 'string' && promet.iznos.trim() !== '') {
                    const iznosSaTockom = promet.iznos.replace(',', '.')
                    const iznosFloat = parseFloat(iznosSaTockom)
                    const iznosUCentima = Math.round(iznosFloat * 100)
                    this.availableFunds = iznosUCentima
                  }
                  break
                case 'KARTICA':
                  if (typeof promet.iznos === 'string' && promet.iznos.trim() !== '') {
                    const iznosSaTockom = promet.iznos.replace(',', '.')
                    const iznosFloat = parseFloat(iznosSaTockom)
                    const iznosUCentima = Math.round(iznosFloat * 100)
                    this.cardFunds = iznosUCentima
                  }
                  break
                case 'OSTALO':
                  if (typeof promet.iznos === 'string' && promet.iznos.trim() !== '') {
                    const iznosSaTockom = promet.iznos.replace(',', '.')
                    const iznosFloat = parseFloat(iznosSaTockom)
                    const iznosUCentima = Math.round(iznosFloat * 100)
                    this.otherFunds = iznosUCentima
                  }
                  break
                default:
                  break
              }
            })
          }

          if (result.data.balance_report?.napojnice_gotovina) {
            const iznosSaTockom = result.data.balance_report?.napojnice_gotovina.replace(',', '.')
            const iznosFloat = parseFloat(iznosSaTockom)
            const iznosUCentima = Math.round(iznosFloat * 100)
            this.tipCash = iznosUCentima
          }

          if (result.data.balance_report?.napojnice_kartice) {
            const iznosSaTockom = result.data.balance_report?.napojnice_kartice.replace(',', '.')
            const iznosFloat = parseFloat(iznosSaTockom)
            const iznosUCentima = Math.round(iznosFloat * 100)
            this.tipCard = iznosUCentima
          }

          if (result.data.balance_report?.napojnice_ukupno) {
            const iznosSaTockom = result.data.balance_report?.napojnice_ukupno.replace(',', '.')
            const iznosFloat = parseFloat(iznosSaTockom)
            const iznosUCentima = Math.round(iznosFloat * 100)
            this.tipsTotal = iznosUCentima
          }

          // Preračunaj iznos za podizanje na temelju dohvaćenih sredstava i postojećih iznosa
          this.withdrawAmount = ((this.availableFunds / 100) + (this.previousAmt / 100)).toFixed(2) || 0

          this.$emit('dataLoaded', result.data.balance)
        })
        .catch(error => {
          console.error('Error loading balance data:', error)
          if (typeof this.showMsgBox === 'function') {
            this.showMsgBox({
              text: 'Došlo je do greške prilikom dohvaćanja podataka.',
              actions: ['cancel'],
              cancelBtnText: this.$t('$vuetify.close'),
              color: 'error'
            })
          } else {
            alert('Došlo je do greške prilikom dohvaćanja podataka.')
          }
        })
        .finally(() => {
          this.$emit('loading', false)
          this.datePickersDisabled = false // Ponovno omogući pickere
        })
    },
    formatDateForDisplay (dateString) { // Pomoćna funkcija za formatiranje
      if (!dateString) return null
      try {
        const [year, month, day] = dateString.split('-')
        return `${day}.${month}.${year}`
      } catch (e) {
        console.error('Error formatting date for display:', dateString, e)
        return dateString // Vrati originalni string ako dođe do greške
      }
    },
    getTips () {
      this.tips = []
      const query = df.collection('tips')
        .where('register_id', '==', state.getCashRegister().id)
        .where('created', '>', this.lastBalanceTipeStamp)

      query
        .onSnapshot((doc) => {
          this.tips = []

          var tipCash = 0
          var tipCard = 0
          var tipsTotal = 0

          doc.docs.forEach((rec) => {
            var tip = rec.data()

            tipsTotal += tip.tip_amount

            if (tip.tip_payment_method === 'NOVČANICE') {
              tipCash += tip.tip_amount
            }

            if (tip.tip_payment_method === 'KARTICA') {
              tipCard += tip.tip_amount
            }
            this.tips.push(tip)
          })

          this.tipCard = tipCard
          this.tipCash = tipCash
          this.tipsTotal = tipsTotal

          if (doc.docs.length === 0) {
            this.tips = []
          }
        }
        )
    },
    resetReceiptPrint () {
      this.receiptPrint = true
    },
    resetValues () {
      this.cashLeft = 0
      this.availableFunds = 0
      this.depositAmt = 0
      this.maxHoldingAmt = 0
    }
  }
}
</script>
